/** GitHub release tag (e.g. `v7.3.1`) or commit SHA, baked at build time. */
export const APP_VERSION: string = __APP_VERSION__;
